export type CookieInformation = {
  name: string;
  purpose: string;
  expires: string;
};

const essentialCookieInformation: CookieInformation[] = [
  {
    name: "persist:cpl-client-portal-auth",
    purpose: "Used to persist certain authentication related data even when refreshing",
    expires: "Never",
  },
  {
    name: "cpl_cookie_preferences",
    purpose: "Used to store user cookie preference data",
    expires: "6 months",
  },
  {
    name: "cplimage[...]",
    purpose: "Used to store tokens and token expiry needed to authenticate and display images",
    expires: "Never",
  },
  {
    name: "cplsession[...]",
    purpose: "Used to store tokens and token expiry needed to authenticate the user's session",
    expires: "Never",
  },
];
const functionalCookieInformation: CookieInformation[] = [
  {
    name: "cpl-autosave-",
    purpose:
      "Used to autosave text in certain text input fields so the text isn't lost when refreshing or navigating to another page",
    expires: "Never",
  },
];
const analyticsCookieInformation: CookieInformation[] = [
  {
    name: "ai_user",
    purpose:
      "Used by Microsoft Application Insights software to collect statistical usage and telemetry information. Detects how many people used the app and its features. Users are counted using anonymous IDs.",
    expires: "1 year",
  },
  {
    name: "ai_session",
    purpose:
      "Used by Microsoft Application Insights software to collect statistical usage and telemetry information. Detects how many sessions of user activity have included certain pages and features of the app.",
    expires: "30 minutes",
  },
];

export { essentialCookieInformation, functionalCookieInformation, analyticsCookieInformation };
